import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { RuleInterface } from '@vendasta/automata';
import { AutomationReplacementChipsComponent } from '../../../../../common/components';
import { CampaignSelectorService } from '../../../../../data-services/campaign-selector.service';
import { GalaxyTagsModule } from '@vendasta/galaxy/tags';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'automata-start-campaign-for-company-panel',
  templateUrl: './start-campaign-for-company-panel.component.html',
  styleUrls: ['./start-campaign-for-company-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    TranslateModule,
    MatIconModule,
    MatSelectModule,
    AutomationReplacementChipsComponent,
    GalaxyTagsModule,
  ],
})
export class StartCampaignForCompanyPanelComponent extends CommonActionPanelComponent implements OnInit {
  campaignIdControl: FormControl = new FormControl('');

  constructor(protected readonly campaignSelectorService: CampaignSelectorService) {
    super();
  }

  ngOnInit(): void {
    // Only add required validator if not in template context
    if (!this.isTemplateContext) {
      this.campaignIdControl.addValidators([Validators.required]);
    }

    const jsonData = this.step ? JSON.parse(this.step?.data || '') : {};
    this.campaignIdControl.setValue(jsonData.campaign_id);
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    const jsonData = this.step ? JSON.parse(this.step?.data || '') : {};
    jsonData.campaign_id = this.campaignIdControl.value;

    return jsonData;
  }

  finishedLoadingSelector(): void {
    this.savingEnabled = true;
  }

  isFormValid(): boolean {
    return this.campaignIdControl.valid;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.campaignIdControl];
  }
}
